import React from 'react';
import { StepValidationResult } from '../../../../../helpers/stepValidation';

interface ValidationInfoBoxProps {
    validationResult: StepValidationResult;
}

export const ValidationInfoBox: React.FC<ValidationInfoBoxProps> = ({ validationResult }) => {
    if (validationResult.isValid) {
        return null;
    }

    return (
        <div style={{ background: '#fff3cd', border: '1px solid #ffeaa7', padding: '10px', marginBottom: '20px' }}>
            <strong>Info:</strong> Die folgenden Schritte enthalten keine Felder:
            <ul style={{ margin: '0.5rem 0 0.5rem 1.5rem', padding: 0 }}>
                {validationResult.emptySteps.map(({ stepNumber, stepTitle }) => (
                    <li key={stepNumber} style={{ margin: '0.25rem 0' }}>
                        <strong>{stepTitle}</strong> (Schritt {stepNumber})
                    </li>
                ))}
            </ul>
            Bitte fügen Sie mindestens ein Feld zu jedem Schritt hinzu, bevor Sie speichern.
        </div>
    );
};

